import { render, staticRenderFns } from "./CarApprove.vue?vue&type=template&id=2ec282d6&"
import script from "./CarApprove.vue?vue&type=script&lang=js&"
export * from "./CarApprove.vue?vue&type=script&lang=js&"
import style0 from "./CarApprove.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports